exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-6d24d1fa]{border:1px solid #939393!important;border-radius:0}.card-body[data-v-6d24d1fa]{padding:0}.card-header[data-v-6d24d1fa]{border:0;background-color:#fff;padding:0}", ""]);

// exports
